module.exports = __webpack_public_path__ + "assets/img/introduction-zh.fa2fea33.png";